<template>
	<v-avatar
		v-bind="avatarProps"
		class="ao-avatar"
	>
		<!-- 1. Если передан `icon`, показываем иконку -->
		<AoIcon
			v-if="iconName"
			:iconName="iconName"
		/>

		<!-- 2. Иначе, если передана `image`, показываем изображение -->
		<v-img
			v-else-if="image"
			:src="image"
			:alt="text || 'avatar'"
			:cover="imageCover"
		/>

		<!-- 3. Иначе, если передан `text`, показываем текст (например, инициалы) -->
		<span
			v-else-if="text"
			class="text-uppercase"
		>
			{{ text }}
		</span>

		<!-- 4. В противном случае, используем default слот для полной кастомизации -->
		<slot v-else />
	</v-avatar>
</template>

<script setup>
import { computed } from 'vue'

import AoIcon from './AoIcon.vue'

const props = defineProps({
	// --- Пропсы для контента ---
	iconName: {
		type: String,
		default: null,
	},
	image: {
		type: String,
		default: null,
	},
	text: {
		type: String,
		default: null,
	},

	imageCover: {
		type: Boolean,
		default: false,
	},

	// --- Пропсы для стилизации и разметки из документации Vuetify ---
	border: {
		type: [String, Number, Boolean],
		default: false,
	},
	color: {
		type: String,
	},
	density: {
		type: String,
		validator: (v) => ['default', 'comfortable', 'compact'].includes(v),
	},
	/* Applies margin at the start of the component */
	end: Boolean,
	rounded: [String, Number, Boolean],
	size: {
		type: [String, Number],
		default: 'default',
		validator: (v) => {
			if (typeof v === 'number') return true
			return ['x-small', 'small', 'default', 'large', 'x-large'].includes(v)
		},
	},
	/* Applies margin at the end of the component */
	start: Boolean,
	tag: {
		type: String,
		default: 'div',
	},
	tile: {
		type: Boolean,
		default: false,
	},
	variant: {
		type: String,
		default: 'flat',
		validator: (v) => ['text', 'flat', 'elevated', 'tonal', 'outlined', 'plain'].includes(v),
	},
})

const avatarProps = computed(() => ({
	image: props.image,
	border: props.border,
	color: props.color,
	density: props.density,
	end: props.end,
	rounded: props.rounded,
	size: props.size,
	start: props.start,
	tag: props.tag,
	tile: props.tile,
	variant: props.variant,
}))
</script>

<style lang="scss">
// .initials {
// 	font-family: 'Manrope', Inter, sans-serif;
// 	font-style: normal;
// 	font-weight: 700;
// 	font-size: 12px;
// 	line-height: 16px;
// }
</style>
